import React from 'react';

import { Flex } from '@qality/common-components/src/atoms/Flex';
import { Table } from '@qality/common-components/src/atoms/Table';
import { Text } from '@qality/common-components/src/atoms/Text';
import { FEATURE_FLAG } from '@qality/common-config';

import {
  NUMBER_OF_COLUMNS_FREE,
  NUMBER_OF_COLUMNS_PREMIUM,
} from '../../TestCasesInCycleTableHeader';

export function TestCasesInCycleTableRowEmpty(): JSX.Element {
  const colSpan = FEATURE_FLAG.isPremium
    ? NUMBER_OF_COLUMNS_PREMIUM
    : NUMBER_OF_COLUMNS_FREE;

  return (
    <Table.Tr>
      <Table.Td colSpan={colSpan}>
        <Flex justifyCenter paddingSize='medium'>
          <Text>No Test Cases were found.</Text>
        </Flex>
      </Table.Td>
    </Table.Tr>
  );
}
